import Signin from './signin/Signin.vue'

export const routes = [
    {
        path: '/auth',
        name: 'signin',
        component: Signin
    }
]
